<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0495 9.08902H8.56055"
      :stroke="clr ? clr : '#323232'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <ellipse
      cx="9.01258"
      cy="8.63709"
      rx="6.75281"
      ry="6.75281"
      :stroke="clr ? clr : '#323232'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5607 9.08918V4.88574"
      :stroke="clr ? clr : '#323232'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
